/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfilePreviewAddress } from './StoreProfilePreviewAddress';
import {
    StoreProfilePreviewAddressFromJSON,
    StoreProfilePreviewAddressFromJSONTyped,
    StoreProfilePreviewAddressToJSON,
    StoreProfilePreviewAddressToJSONTyped,
} from './StoreProfilePreviewAddress';
import type { StoreProfileDetailsOpeningHours } from './StoreProfileDetailsOpeningHours';
import {
    StoreProfileDetailsOpeningHoursFromJSON,
    StoreProfileDetailsOpeningHoursFromJSONTyped,
    StoreProfileDetailsOpeningHoursToJSON,
    StoreProfileDetailsOpeningHoursToJSONTyped,
} from './StoreProfileDetailsOpeningHours';

/**
 * 
 * @export
 * @interface StoreProfilePreviewQuery
 */
export interface StoreProfilePreviewQuery {
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewQuery
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewQuery
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewQuery
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewQuery
     */
    phoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfilePreviewQuery
     */
    isOts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfilePreviewQuery
     */
    isWpn: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewQuery
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewQuery
     */
    banner?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewQuery
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewQuery
     */
    openingYear?: string;
    /**
     * 
     * @type {StoreProfilePreviewAddress}
     * @memberof StoreProfilePreviewQuery
     */
    address?: StoreProfilePreviewAddress;
    /**
     * 
     * @type {StoreProfileDetailsOpeningHours}
     * @memberof StoreProfilePreviewQuery
     */
    openingHours: StoreProfileDetailsOpeningHours;
    /**
     * 
     * @type {Array<StoreProfilePreviewQueryTypesEnum>}
     * @memberof StoreProfilePreviewQuery
     */
    types: Array<StoreProfilePreviewQueryTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfilePreviewQuery
     */
    activities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfilePreviewQuery
     */
    paymentMethods?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfilePreviewQuery
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfilePreviewQuery
     */
    accessibilities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfilePreviewQuery
     */
    equipments?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfilePreviewQuery
     */
    gallery?: Array<string>;
}


/**
 * @export
 */
export const StoreProfilePreviewQueryTypesEnum = {
    Online: 'online',
    Local: 'local'
} as const;
export type StoreProfilePreviewQueryTypesEnum = typeof StoreProfilePreviewQueryTypesEnum[keyof typeof StoreProfilePreviewQueryTypesEnum];


/**
 * Check if a given object implements the StoreProfilePreviewQuery interface.
 */
export function instanceOfStoreProfilePreviewQuery(value: object): value is StoreProfilePreviewQuery {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isOts' in value) || value['isOts'] === undefined) return false;
    if (!('isWpn' in value) || value['isWpn'] === undefined) return false;
    if (!('openingHours' in value) || value['openingHours'] === undefined) return false;
    if (!('types' in value) || value['types'] === undefined) return false;
    return true;
}

export function StoreProfilePreviewQueryFromJSON(json: any): StoreProfilePreviewQuery {
    return StoreProfilePreviewQueryFromJSONTyped(json, false);
}

export function StoreProfilePreviewQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfilePreviewQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'isOts': json['isOts'],
        'isWpn': json['isWpn'],
        'website': json['website'] == null ? undefined : json['website'],
        'banner': json['banner'] == null ? undefined : json['banner'],
        'image': json['image'] == null ? undefined : json['image'],
        'openingYear': json['openingYear'] == null ? undefined : json['openingYear'],
        'address': json['address'] == null ? undefined : StoreProfilePreviewAddressFromJSON(json['address']),
        'openingHours': StoreProfileDetailsOpeningHoursFromJSON(json['openingHours']),
        'types': json['types'],
        'activities': json['activities'] == null ? undefined : json['activities'],
        'paymentMethods': json['paymentMethods'] == null ? undefined : json['paymentMethods'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'accessibilities': json['accessibilities'] == null ? undefined : json['accessibilities'],
        'equipments': json['equipments'] == null ? undefined : json['equipments'],
        'gallery': json['gallery'] == null ? undefined : json['gallery'],
    };
}

export function StoreProfilePreviewQueryToJSON(json: any): StoreProfilePreviewQuery {
    return StoreProfilePreviewQueryToJSONTyped(json, false);
}

export function StoreProfilePreviewQueryToJSONTyped(value?: StoreProfilePreviewQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'isOts': value['isOts'],
        'isWpn': value['isWpn'],
        'website': value['website'],
        'banner': value['banner'],
        'image': value['image'],
        'openingYear': value['openingYear'],
        'address': StoreProfilePreviewAddressToJSON(value['address']),
        'openingHours': StoreProfileDetailsOpeningHoursToJSON(value['openingHours']),
        'types': value['types'],
        'activities': value['activities'],
        'paymentMethods': value['paymentMethods'],
        'categories': value['categories'],
        'accessibilities': value['accessibilities'],
        'equipments': value['equipments'],
        'gallery': value['gallery'],
    };
}

